import "typeface-open-sans";

import { Button } from "../../Button/Button";
import { Icon, IconType } from "../../Icon/Icon";

import "../../../App.scss";
import "./IPAddressError.scss";

export default function IPAddressError(): JSX.Element {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="ip-error">
      <div className="ip-error-box">
        <Icon className="ip-error-icon" type={IconType.Warning} />
        <h3 className=" ip-error-title">Your IP Address Has Changed</h3>
        <div className="ip-error-description">
          <p>
            We have detected that your network connection has changed. This may be due to a network
            change or a VPN disconnection. To protect your data, access to the interface is
            temporarily suspended. Any unsaved data will be lost.
          </p>
          <p>
            Please reload the page to continue. If the connection problem persists, please contact
            your system administrator.
          </p>
        </div>
        <Button
          onClick={handleReload}
          className="ip-error-btn"
          iconType={IconType.Refresh}
          label="Reload Page"
        />
      </div>
    </div>
  );
}
